<script>
import { mapState } from 'vuex';

import UnraidSvgUiKey from '@unraid/shared-components/assets/svg/ui/key.svg';
import UnraidSvgUtilNewWindow from '@unraid/shared-components/assets/svg/util/new-window.svg';

export default {
  props: {
    payload: {
      type: Object,
    },
    text: {
      type: String,
    },
    emphasize: {
      type: Boolean,
      default: false,
    },
    external: {
      type: Boolean,
      default: true,
    },
    noIframeAllowed: {
      type: Boolean,
      default: false,
    },
  },
  components: { UnraidSvgUiKey, UnraidSvgUtilNewWindow },
  computed: {
    ...mapState(['iframeUrl']),
  },
};
</script>

<template>
  <li>
    <a
      v-if="noIframeAllowed && iframeUrl"
      :href="iframeUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="group flex flex-row items-center justify-between"
      :class="{
        'btn-emphasize': emphasize
      }"
      :title="external ? `${$t('upc.opensNewHttpsWindow.base', [text])}` : null"
    >
      <span class="inline-flex flex-row items-center">
        <UnraidSvgUiKey class="fill-current w-12px h-12px mr-8px" />
        {{ text }} (new tab)
      </span>
      <UnraidSvgUtilNewWindow v-if="external" class="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200 ease-in-out fill-current w-12px h-12px ml-8px" />
    </a>
    <button
      v-else
      @click="$emit('click')"
      class="group flex flex-row items-center justify-between"
      :class="{
        'btn-emphasize': emphasize
      }"
      :title="external ? `${$t('upc.opensNewHttpsWindow.base', [text])}` : null"
    >
      <span class="inline-flex flex-row items-center">
        <UnraidSvgUiKey class="fill-current w-12px h-12px mr-8px" />
        {{ text }}
      </span>
      <UnraidSvgUtilNewWindow v-if="external" class="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200 ease-in-out fill-current w-12px h-12px ml-8px" />
    </button>
  </li>
</template>
